import { render, staticRenderFns } from "./TemplateSmsCreate.vue?vue&type=template&id=bb2f6d44&"
import script from "./TemplateSmsCreate.vue?vue&type=script&lang=js&"
export * from "./TemplateSmsCreate.vue?vue&type=script&lang=js&"
import style0 from "./TemplateSmsCreate.vue?vue&type=style&index=0&scope=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports